import React from 'react';
import { connect } from 'react-redux';
import ResultsExcelTablePres from '../presentational/ResultsExcelTablePres';

let index = 0;

class ResultsExcelTableContainer extends React.Component {
  state = {
    results: this.props.results.map(result => {
      result.id = index;
      result.type = 'Employee Type ' + ++index;
      return result;
    }),
  };

  componentDidMount() {
    index = 0;
  }

  render() {
    return <ResultsExcelTablePres {...this.props} {...this.state} />;
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ResultsExcelTableContainer);
